import { useEffect, useRef } from "react";

export const DATA_CHANGED_EVENT = "racinefit:data-changed";

export const notifyDataChanged = (detail) => {
  window.dispatchEvent(new CustomEvent(DATA_CHANGED_EVENT, { detail: { ...detail, at: Date.now() } }));
};

export const useDataChanges = (onChange) => {
  const latest = useRef(onChange);
  latest.current = onChange;

  useEffect(() => {
    const handleChange = (event) => latest.current(event.detail || {});
    window.addEventListener(DATA_CHANGED_EVENT, handleChange);
    return () => window.removeEventListener(DATA_CHANGED_EVENT, handleChange);
  }, []);
};